export default "__VITE_ASSET__CtO6q_bd__"